import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\StaffController::index
 * @see app/Http/Controllers/StaffController.php:22
 * @route '/staff'
 */
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/staff',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\StaffController::index
 * @see app/Http/Controllers/StaffController.php:22
 * @route '/staff'
 */
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\StaffController::index
 * @see app/Http/Controllers/StaffController.php:22
 * @route '/staff'
 */
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\StaffController::index
 * @see app/Http/Controllers/StaffController.php:22
 * @route '/staff'
 */
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\StaffController::show
 * @see app/Http/Controllers/StaffController.php:338
 * @route '/staff/{staff}'
 */
export const show = (args: { staff: string | number } | [staff: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/staff/{staff}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\StaffController::show
 * @see app/Http/Controllers/StaffController.php:338
 * @route '/staff/{staff}'
 */
show.url = (args: { staff: string | number } | [staff: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { staff: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    staff: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        staff: args.staff,
                }

    return show.definition.url
            .replace('{staff}', String(parsedArgs.staff ?? ''))
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\StaffController::show
 * @see app/Http/Controllers/StaffController.php:338
 * @route '/staff/{staff}'
 */
show.get = (args: { staff: string | number } | [staff: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\StaffController::show
 * @see app/Http/Controllers/StaffController.php:338
 * @route '/staff/{staff}'
 */
show.head = (args: { staff: string | number } | [staff: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\StaffController::auascv
 * @see app/Http/Controllers/StaffController.php:351
 * @route '/auascv/{staff}'
 */
export const auascv = (args: { staff: string | number } | [staff: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: auascv.url(args, options),
    method: 'get',
})

auascv.definition = {
    methods: ["get","head"],
    url: '/auascv/{staff}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\StaffController::auascv
 * @see app/Http/Controllers/StaffController.php:351
 * @route '/auascv/{staff}'
 */
auascv.url = (args: { staff: string | number } | [staff: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { staff: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    staff: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        staff: args.staff,
                }

    return auascv.definition.url
            .replace('{staff}', String(parsedArgs.staff ?? ''))
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\StaffController::auascv
 * @see app/Http/Controllers/StaffController.php:351
 * @route '/auascv/{staff}'
 */
auascv.get = (args: { staff: string | number } | [staff: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: auascv.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\StaffController::auascv
 * @see app/Http/Controllers/StaffController.php:351
 * @route '/auascv/{staff}'
 */
auascv.head = (args: { staff: string | number } | [staff: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: auascv.url(args, options),
    method: 'head',
})
const staff = {
    index: Object.assign(index, index),
show: Object.assign(show, show),
auascv: Object.assign(auascv, auascv),
}

export default staff